import { render, staticRenderFns } from "./ForumThreads.vue?vue&type=template&id=28125bda&scoped=true&"
import script from "./ForumThreads.vue?vue&type=script&lang=js&"
export * from "./ForumThreads.vue?vue&type=script&lang=js&"
import style0 from "./ForumThreads.vue?vue&type=style&index=0&id=28125bda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28125bda",
  null
  
)

export default component.exports